module.exports = __webpack_public_path__ + "static/media/winner.cc0fa713.png";